import type { TranslationTree } from '../../types';

export const auth: TranslationTree = {
  auth: {
    loading: 'Chargement…',
    hero: {
      badge: 'Connexion ToolLife',
      title: 'Gestion du cycle de vie des outils',
      description:
        "Gérez la traçabilité, l'analytique et le suivi du cycle de vie des outils de fraisage depuis une seule plateforme.",
      tagline: 'Traçabilité · Analytique · Suivi des outils',
      promises: {
        traceability: {
          title: 'Traçabilité instantanée',
          description:
            "Enregistrez les opérations par scan QR ou saisie manuelle et consultez l'historique par outil.",
        },
        machineControl: {
          title: 'Analytique',
          description:
            "Visualisez les KPI et comparez plusieurs références d'outils sur le tableau de bord analytique.",
        },
        security: {
          title: 'Sécurité maîtrisée',
          description: "Connexions chiffrées et contrôle d'accès basé sur les rôles.",
        },
      },
    },
    login: {
      badge: 'Portail sécurisé',
      title: 'Connectez-vous à ToolLife',
      description: 'Saisissez vos identifiants pour accéder à la plateforme.',
      fields: {
        email: {
          label: 'Adresse e-mail',
          placeholder: 'prenom.nom@entreprise.fr',
        },
        password: {
          label: 'Mot de passe',
          placeholder: '••••••••',
          show: 'Afficher le mot de passe',
          hide: 'Masquer le mot de passe',
        },
        remember: 'Se souvenir de moi sur cet appareil',
      },
      button: {
        idle: 'Se connecter',
        submitting: 'Connexion en cours…',
      },
      errors: {
        unexpected: 'Une erreur inattendue est survenue.',
      },
      footer: {
        notice: 'Connectez-vous uniquement depuis un appareil de confiance.',
      },
    },
    highlights: {
      security: {
        title: 'Sécurité au cœur',
        description: 'Authentification chiffrée et gestion des accès par rôle.',
      },
      liveMonitoring: {
        title: 'Vue des outils',
        description:
          'Parcourez la liste des outils, consultez leur indicateur de statut et affichez leur historique de traçabilité.',
      },
      automation: {
        title: 'Saisie de traçabilité',
        description:
          'Enregistrez une opération par scan QR ou formulaire manuel en capturant machine, matière et porte-outil.',
      },
      experience: {
        title: 'Interface multilingue',
        description:
          "L'interface est disponible en anglais, français et allemand, sélectionnable depuis l'écran de connexion.",
      },
    },
    support: {
      title: 'Support',
      description:
        "Contactez-nous pour toute question d'installation, d'onboarding ou de sécurité.",
      email: 'ing.toollife@he-arc.ch',
      instructions: 'Répondez à cet e-mail et nous vous recontacterons.',
    },
    password: {
      requirements: {
        hint: 'Au moins 8 caractères, une majuscule, une minuscule et un chiffre.',
      },
    },
  },
};
